"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondsToDuration = void 0;
const secondsToDuration = (seconds) => `${Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}`;
exports.secondsToDuration = secondsToDuration;
